var chunkMapping = {
	"node_modules_babel-loader_lib_index_js_ruleSet_1_rules_1_use_src_bootstrap_js": [
		37350,
		29222,
		41584,
		86386,
		87019,
		9551,
		21134,
		87548,
		69733,
		17817,
		43484,
		88069,
		5449,
		30686,
		11396,
		30421,
		89030,
		14113,
		12255,
		46570
	],
	"webpack_container_remote_contacts_AddContactContainer": [
		828
	],
	"webpack_container_remote_contacts_ContactForm": [
		48544
	],
	"src_federatedModules_Files_FilesSliceWrapper_js": [
		33589
	],
	"src_federatedModules_Files_FilesModule_SecureFilesModule_js": [
		52054
	],
	"webpack_container_remote_attachments_PreviewModal": [
		63686
	],
	"webpack_container_remote_attachments_DeleteFilesModal": [
		40126
	],
	"webpack_container_remote_attachments_ShareModal": [
		3515
	],
	"webpack_container_remote_attachments_AttachmentsSubscription": [
		67918
	],
	"webpack_container_remote_communications_moduleExport_messagesHistory": [
		83315
	],
	"webpack_container_remote_communications_moduleExport_conversationHistory": [
		73843
	],
	"webpack_container_remote_communications_moduleExport_communications": [
		52030
	],
	"webpack_container_remote_communications_moduleExport_communicationLayout": [
		74501
	],
	"webpack_container_remote_mediacalls_stateManagement": [
		39771
	],
	"webpack_container_remote_email_stateManagement": [
		48460
	],
	"webpack_container_remote_browserSoftphone_index_js": [
		987
	],
	"webpack_container_remote_mediacalls_MediaCallsModule": [
		67081
	],
	"webpack_container_remote_mediacalls_Notifications": [
		25825
	],
	"webpack_container_remote_mediacalls_VideoCallPopup": [
		10497
	],
	"webpack_container_remote_mediacalls_VideoMeeting": [
		29521
	],
	"webpack_container_remote_mediacalls_MeetingProvider": [
		87701
	],
	"webpack_container_remote_mediacalls_actions": [
		78419
	],
	"webpack_container_remote_mediacalls_meetingUtils": [
		11731
	],
	"webpack_container_remote_messaging_messagingProvider": [
		39436
	],
	"webpack_container_remote_contacts_InviteErrorModal": [
		82713
	],
	"webpack_container_remote_mediaSettings_useMediaSettingsStorage": [
		17878
	],
	"webpack_container_remote_attachments_OpenFileUrlListener": [
		72457
	],
	"src_federatedModules_Chat_WindowFeed_Feed_js": [
		43759
	],
	"webpack_container_remote_communications_CommunicationNavigation": [
		52594
	],
	"src_federatedModules_InfoCard_InfoCard_js": [
		29188,
		84960
	],
	"webpack_container_remote_browserSoftphone_redux": [
		81567
	],
	"src_federatedModules_FreemiumBanner_FreemiumBanner_js": [
		31135
	],
	"src_Layout_MiniViewLeftNav_MiniViewLeftNav_tsx": [
		39723,
		40803,
		95657
	],
	"webpack_container_remote_email_ChannelPanel": [
		72919
	]
};
var idToExternalAndNameMapping = {
	"828": [
		"default",
		"./AddContactContainer",
		51240
	],
	"987": [
		"default",
		"./index.js",
		10355
	],
	"3515": [
		"default",
		"./ShareModal",
		27362
	],
	"5449": [
		"default",
		"./stateManagement",
		16701
	],
	"9551": [
		"default",
		"./contactsManagement",
		51240
	],
	"10497": [
		"default",
		"./VideoCallPopup",
		67222
	],
	"11396": [
		"default",
		"./moduleExport",
		85081
	],
	"11731": [
		"default",
		"./meetingUtils",
		67222
	],
	"12255": [
		"default",
		"./components",
		27354
	],
	"14113": [
		"default",
		"./LeftNavDataLoader",
		72271
	],
	"17817": [
		"default",
		"./providers",
		72271
	],
	"17878": [
		"default",
		"./useMediaSettingsStorage",
		75485
	],
	"21134": [
		"default",
		"./stateManagement",
		33503
	],
	"25825": [
		"default",
		"./Notifications",
		67222
	],
	"29188": [
		"default",
		"./InfoCard",
		80006
	],
	"29222": [
		"default",
		"./ContactsModule",
		51240
	],
	"29521": [
		"default",
		"./VideoMeeting",
		67222
	],
	"30421": [
		"default",
		"./CasApplicationsDialog",
		33503
	],
	"30686": [
		"default",
		"./ChatRoomsModule",
		85081
	],
	"31135": [
		"default",
		"./FreemiumBanner",
		6494
	],
	"33589": [
		"default",
		"./stateManagement",
		27362
	],
	"37350": [
		"default",
		"./useUnreadCount",
		72271
	],
	"39436": [
		"default",
		"./messagingProvider",
		64081
	],
	"39723": [
		"default",
		"./useBadgeCountUpdate",
		72271
	],
	"39771": [
		"default",
		"./stateManagement",
		67222
	],
	"40126": [
		"default",
		"./DeleteFilesModal",
		27362
	],
	"40803": [
		"default",
		"./usePhoneNumbers",
		72271
	],
	"41584": [
		"default",
		"./SFFProfileView",
		51240
	],
	"43484": [
		"default",
		"./Contact",
		51240
	],
	"43759": [
		"default",
		"./ChatWindowModule",
		85081
	],
	"46570": [
		"default",
		"./UseVoiceCallRestriction",
		10355
	],
	"48460": [
		"default",
		"./stateManagement",
		3477
	],
	"48544": [
		"default",
		"./ContactForm",
		51240
	],
	"52030": [
		"default",
		"./moduleExport/communications",
		72271
	],
	"52054": [
		"default",
		"./FilesModule",
		27362
	],
	"52594": [
		"default",
		"./CommunicationNavigation",
		72271
	],
	"63686": [
		"default",
		"./PreviewModal",
		27362
	],
	"67081": [
		"default",
		"./MediaCallsModule",
		67222
	],
	"67918": [
		"default",
		"./AttachmentsSubscription",
		27362
	],
	"69733": [
		"default",
		"./components/CommunicationsSubscription",
		72271
	],
	"72457": [
		"default",
		"./OpenFileUrlListener",
		27362
	],
	"72919": [
		"default",
		"./ChannelPanel",
		3477
	],
	"73843": [
		"default",
		"./moduleExport/conversationHistory",
		72271
	],
	"74501": [
		"default",
		"./moduleExport/communicationLayout",
		72271
	],
	"78419": [
		"default",
		"./actions",
		67222
	],
	"81567": [
		"default",
		"./redux",
		10355
	],
	"82713": [
		"default",
		"./InviteErrorModal",
		51240
	],
	"83315": [
		"default",
		"./moduleExport/messagesHistory",
		72271
	],
	"84960": [
		"default",
		"./redux",
		80006
	],
	"86386": [
		"default",
		"./hooks",
		64081
	],
	"87019": [
		"default",
		"./utils",
		64081
	],
	"87548": [
		"default",
		"./moduleExport",
		27354
	],
	"87701": [
		"default",
		"./MeetingProvider",
		67222
	],
	"88069": [
		"default",
		"./CalendarModule",
		16701
	],
	"89030": [
		"default",
		"./CommunicationsModule",
		72271
	],
	"95657": [
		"default",
		"./useRdsMessages",
		72271
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}